/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Component } from 'react';
import { Header, Progress, Select } from "@scuf/common";
import { inject, observer } from "mobx-react";
import { IGatewayIdentityProps, IGatewayIdentityState } from './IGatewayIdentityInterfaces';
import './GatewayIdentity.scss';
import GatewayList from '../VirtualGateway/GatewayList/GatewayList'
import DIYAppConstants from '../../utils/DIYAppConstants';
import GatewayIdentityStore from '../../stores/GatewayManager/GatewayIdentityStore';

@observer
@inject(DIYAppConstants.GATEWAY_IDENTITY_STORE)
export default class GatewayIdentity extends Component<IGatewayIdentityProps, IGatewayIdentityState> {

  gatewayIdentityStore: GatewayIdentityStore;

  constructor(props: IGatewayIdentityProps) {
    super(props);
    this.initializeState();
    this.gatewayIdentityStore = props.gatewayIdentityStore!;
  }

  componentDidMount() {
    let tmpList: any = [];
    this.gatewayIdentityStore!.getSiteList().then((response) => {
      let siteListObject = response.data;
      if (siteListObject && siteListObject.StatusCode === 200 && siteListObject.Result) {
        let sites = siteListObject.Result;
        this.setState({ sitesLoaded: true });
        sites.forEach((site: any) => {
          tmpList.push({
            value: site['OrganizationId'],
            text: site['OrganizationName']
          });
        });
      }
      this.setState({ sitesLoaded: true, siteList: tmpList });
    }).catch(() => {
      this.setState({ sitesLoaded: true });
    });
  }

  render() {
    return <div className='root'>
      <div className='application-header'>
        <Header title="Connect" logo={false} isForge={true} menu={false}
          className='ui-application-header'>
          <Header.UserProfile firstName={this.state.firstName}
            lastName={this.state.lastName}>
            <Header.UserProfile.Item onClick={() => {
              this.props.logout!();
            }}>Log out</Header.UserProfile.Item>
            <Header.UserProfile.Item onClick={() => {
              window.open("/license.txt")
            }}>License</Header.UserProfile.Item>
          </Header.UserProfile>
        </Header>
      </div>
      <div className='application-container'>
        <div className='application-main-content'>
          <div className='application-page-content-no-nav ui-gateway-identity-container'>
            <div className='page-title'>Select your Gateway</div>
            {!this.state.sitesLoaded ?
              (<div className="content-loading">
                <Progress circular={true}></Progress>
              </div>) : (this.displayListComponent())
            }
          </div>
        </div>
      </div>
    </div>;
  }

  private initializeState() {
    let userInfo = this.props.userInfo!;
    this.state = {
      featureFlagUserContextInitialized: false,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      sitesLoaded: false,
      siteList: [],
      selectedSite: ''
    };
  }

  onSiteSelection = (value: string) => {
    this.setState({ selectedSite: value });
  }

  displayListComponent = () => { 
    return (
      <div className="identity-wrapper">
        <div className='gw-form-field'>
          <Select search={true} onChange={(value) => this.onSiteSelection(value)} options={this.state.siteList} placeholder="Select your site to begin" label="Select your Location" />
        </div>
        {this.state.selectedSite ? (
          <div className="list-wrapper">
            <GatewayList siteId={this.state.selectedSite}></GatewayList>
          </div>) : <div></div>}
      </div>
    );
  }


}
